import React, { useEffect, useRef, useState } from "react";
import { Menu, ChevronDown, LogOut } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import Mainlogo from "../../Assets/Logos/mainlogo.webp";
import Union from "../../Assets/Logos/Union.png";

const BottomNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [userData, setUserData] = useState(null);
  const menuRef = useRef(null);
  const userDropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const navigateNow = (path) => {
    navigate(path);
  };

  const menuItems = [
    {
      title: "Home",
      path: "/",
    },
    {
      title: "Investment Corner",
      path: "/investment-corner",
    },
    {
      title: "About Us",
      path: "/about",
    },
    {
      title: "Projects",
      path: "/projects",
      // options: [
      //   { title: "Project 1", path: "/project-1" },
      //   { title: "Project 2", path: "/project-2" },
      // ],
    },
    {
      title: "Blogs",
      path: "/blogs",
    },
    {
      title: "Contact",
      path: "/contact",
    },
  ];

  // Get user data from localStorage
  useEffect(() => {
    const getUserData = () => {
      try {
        const storedUserData = localStorage.getItem("userData");
        if (storedUserData) {
          setUserData(JSON.parse(storedUserData));
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    };

    getUserData();

    // Listen for storage changes (in case user logs in/out in another tab)
    const handleStorageChange = () => {
      getUserData();
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
        setActiveDropdown(null);
      }
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(e.target)
      ) {
        setShowUserDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const handleNavigate = (path) => {
  //   const protectedRoutes = ["/projects"];

  //   if (protectedRoutes.includes(path) && !userData) {
  //     navigateNow("/user-login");
  //   } else {
  //     navigateNow(path);
  //   }

  //   setMenuOpen(false);
  //   setActiveDropdown(null);
  //   setShowUserDropdown(false);
  //   window.scrollTo(0, 0);
  // };

  const handleNavigate = (path) => {
  navigateNow(path);

  setMenuOpen(false);
  setActiveDropdown(null);
  setShowUserDropdown(false);
  window.scrollTo(0, 0);
};


  const handleLogout = () => {
    localStorage.removeItem("userData");
    setUserData(null);
    setShowUserDropdown(false);
    navigateNow("/");
  };

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const getUserDisplayName = () => {
    if (!userData) return "";

    const firstName = userData?.name?.split(" ")[0];
    const title = userData?.gender === "female" ? "Ms." : "Mr.";
    return `${title} ${firstName}`;
  };

  return (
    <div className="w-full z-50">
      <div className="hidden xl:flex items-center justify-between bg-white text-gray-700 px-6 py-2 shadow-sm border-b border-gray-100">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            navigate("/");
          }}
        >
          <img src={Mainlogo} alt="" className="h-16 w-76 hidden md:flex" />
        </div>
        <div className="flex gap-8 font-semibold tracking-wide lg:gap-16 items-center">
          <div className="flex gap-8 items-center text-[18px] font-medium">
            {menuItems.map((item, index) => (
              <div key={index} className="relative">
                {item.options ? (
                  <div
                    className={`flex items-center gap-1 cursor-pointer hover:text-gray-900 transition-colors ${
                      isActiveRoute(item.path)
                        ? "text-orange-500 hover:text-orange-600"
                        : ""
                    }`}
                    onClick={() =>
                      setActiveDropdown(activeDropdown === index ? null : index)
                    }
                  >
                    {item.title} <ChevronDown size={14} />
                  </div>
                ) : (
                  <button
                    onClick={() => handleNavigate(item.path)}
                    className={`hover:text-gray-900 transition-colors ${
                      isActiveRoute(item.path)
                        ? "text-orange-500 hover:text-orange-600"
                        : ""
                    }`}
                  >
                    {item.title}
                  </button>
                )}

                {/* Dropdown */}
                {item.options && activeDropdown === index && (
                  <div className="absolute bg-white text-gray-700 shadow-lg mt-2 rounded-md w-40 overflow-hidden z-50 border border-gray-100">
                    {item.options.map((opt, idx) => (
                      <div
                        key={idx}
                        onClick={() => handleNavigate(opt.path)}
                        className="px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm"
                      >
                        {opt.title}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Login Button or User Profile */}
          {userData ? (
            <div className="relative" ref={userDropdownRef}>
              <div
                className="flex items-center gap-2 cursor-pointer hover:text-gray-900 transition-colors"
                onMouseEnter={() => setShowUserDropdown(true)}
                onMouseLeave={() => setShowUserDropdown(false)}
              >
                <span className="text-[18px] font-medium">
                  {getUserDisplayName()}
                </span>
                <ChevronDown size={14} />
              </div>

              {showUserDropdown && (
                <div
                  className="absolute top-full right-0 mt-0 bg-white shadow-lg rounded-md border border-gray-100 py-2 min-w-[150px] z-50"
                  onMouseEnter={() => setShowUserDropdown(true)}
                  onMouseLeave={() => setShowUserDropdown(false)}
                >
                  <div
                    onClick={handleLogout}
                    className="px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm flex items-center gap-2 text-red-600 hover:text-red-700"
                  >
                    <LogOut size={16} />
                    Logout
                  </div>
                </div>
              )}
            </div>
          ) : (
            <button
              onClick={() => handleNavigate("/user-login")}
              className="bg-primaryOrange hover:bg-orange-600 transition-colors px-8 py-2 rounded-md text-white text-[18px] font-medium"
            >
              Log In
            </button>
          )}
        </div>
      </div>

      {/* Mobile Navbar */}
      <div className="xl:hidden flex justify-between items-center px-6 py-4 bg-white shadow-sm border-b border-gray-100">
        {/* Logo placeholder */}
        <div className="flex items-center">
          <img src={Union} alt="Union Logo" className="h-8 w-8" />
        </div>
        <Menu
          size={24}
          className="text-gray-700 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        />
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            ref={menuRef}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3 }}
            className="fixed top-0 right-0 w-3/4 h-full bg-white shadow-lg z-50 p-6 flex flex-col gap-6"
          >
            <div className="flex justify-between items-center mb-4">
              <div className="text-lg font-bold text-gray-700">Menu</div>
              <button
                className="bg-gray-200 text-gray-700 px-3 py-1 rounded-md text-sm"
                onClick={() => setMenuOpen(false)}
              >
                Close
              </button>
            </div>

            {/* User Info in Mobile Menu */}
            {userData && (
              <div className="border-b border-gray-200 pb-4 mb-4">
                <div className="flex items-center gap-3">
                  {userData.avatar && (
                    <img
                      src={userData.avatar}
                      alt="User Avatar"
                      className="w-10 h-10 rounded-full object-cover"
                    />
                  )}
                  <div>
                    <div className="font-medium text-gray-700">
                      {getUserDisplayName()}
                    </div>
                    <div className="text-sm text-gray-500">
                      {userData.email}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {menuItems.map((item, index) => (
              <div key={index}>
                {item.options ? (
                  <div>
                    <div
                      className={`flex items-center justify-between font-medium cursor-pointer ${
                        isActiveRoute(item.path)
                          ? "text-orange-500"
                          : "text-gray-700"
                      }`}
                      onClick={() =>
                        setActiveDropdown(
                          activeDropdown === index ? null : index
                        )
                      }
                    >
                      {item.title}
                      <ChevronDown />
                    </div>
                    {activeDropdown === index && (
                      <div className="ml-4 mt-2 space-y-2">
                        {item.options.map((opt, idx) => (
                          <div
                            key={idx}
                            className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer"
                            onClick={() => handleNavigate(opt.path)}
                          >
                            {opt.title}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className={`font-medium cursor-pointer ${
                      isActiveRoute(item.path)
                        ? "text-orange-500"
                        : "text-gray-700"
                    }`}
                    onClick={() => handleNavigate(item.path)}
                  >
                    {item.title}
                  </div>
                )}
              </div>
            ))}

            {userData ? (
              <button
                onClick={handleLogout}
                className="mt-auto bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-md w-full text-sm font-medium flex items-center justify-center gap-2"
              >
                <LogOut size={16} />
                Logout
              </button>
            ) : (
              <button
                onClick={() => handleNavigate("/user-login")}
                className="mt-auto bg-orange-500 hover:bg-orange-600 text-white px-5 py-2 rounded-md w-full text-sm font-medium"
              >
                Log In
              </button>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default BottomNavbar;
